import React from 'react';
import PropTypes from 'prop-types';
import CorporatePage from '../../components/CorporatePage';
import content from '../../data/pages/app-store';

const AppStorePage = ({ pageContext: { locale } }) => (
  <CorporatePage locale={locale} path="/solutions/app-store/" content={content} />
);

AppStorePage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default AppStorePage;
